var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "근로계약서 관리",
      "fullHeight": "",
      "topBtn": ""
    }
  }, [_c('template', {
    slot: "contents"
  }, [_c('div', {
    staticClass: "mb-20 mb-lg-40",
    staticStyle: {
      "flex": "0 0 auto"
    }
  }, [_c('v-badge', {
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("계약서 목록")])])], 1), _vm.contracts.length ? [_c('v-row', [_vm._l(_vm.items, function (value) {
    return [_c('v-col', {
      key: value === null || value === void 0 ? void 0 : value._id,
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('employment-contract-item', _vm._g(_vm._b({}, 'employment-contract-item', {
      value
    }, false), {
      search: _vm.search
    }))], 1)];
  })], 2), _c('v-pagination', {
    staticClass: "my-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요. "), _c('br'), _vm._v(" 계약서가 없습니다. ")]), _c('v-btn', {
    attrs: {
      "href": "/recruitments",
      "text": "",
      "height": "auto",
      "color": "transparent"
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("채용공고 지원하기")])])], 1)]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }